export default class DashboardJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  /** Admin Dashboard */
  fetchStats(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.dashboardEndpoint}/stats`, {
      params
    })
  }

  fetchGraph(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.dashboardEndpoint}/graph`, {
      params
    })
  }

  /** Tags */
  fetchNavigationTagsData(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.dashboardEndpoint}/tags`, {
      params
    })
  }
}
